// extracted by mini-css-extract-plugin
export var des = "index-module--des--Yd3ko";
export var juriesItemWrapper = "index-module--juriesItemWrapper--IdTjF";
export var juriesTagList = "index-module--juriesTagList--jBmlw";
export var title = "index-module--title--OpO5-";